module.exports = __webpack_public_path__ + "static/media/maryamTelmesani.7178277a.svg";